module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [(_vm.media) ? _c('div', [_c('div', {
    staticClass: "thumbnail"
  }, [_c('a', {
    attrs: {
      "href": _vm.media.filepath,
      "target": "_blank",
      "title": "Otwórz w nowym oknie"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.media.filepath
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.media.filename) + "\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('change')
      }
    }
  }, [_vm._v("Zmień")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('delete', _vm.media)
      }
    }
  }, [_vm._v("Usuń")])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45609e90","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MediaItem.vue
// module id = 441
// module chunks = 1